import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Input, Modal } from 'antd';
import styled from 'styled-components';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { mostrarErro } from '@4beefopag/4bee-fopag-core/dist/molecules';
import Button from '../../atoms/Button';
import { updatePayroll } from '../../../services/repository/payrollRepository';

const { TextArea } = Input;

const ObservacaoTextArea = styled(TextArea)`
  margin-top: 8px;
  margin-bottom: 32px;
  overflow: auto;
  resize: none;
`;

function DrawerEditPayroll({ payroll, onFinishEditing, onCancelClick }) {
  const [observacaoAdmin, setObservacaoAdmin] = useState(payroll && payroll.observacaoAdmin);

  useEffect(() => {
    if (payroll) {
      setObservacaoAdmin(payroll.observacaoAdmin || '');
    }
  }, [payroll]);

  if (!payroll) {
    return <div />;
  }

  const handleUpdatePayrollClick = async (requisicao, body) => {
    try {
      await updatePayroll(requisicao.id, body);
      Modal.success({
        title: 'Sucesso',
        content: <p data-testid="modal-mensagem-sucesso">Requisição salva com sucesso!</p>,
      });
      onFinishEditing(requisicao, body);
    } catch (e) {
      mostrarErro(e);
    }
  };

  return (
    <Drawer
      data-testid="drawer-edit-payroll"
      title="Editar Requisição"
      width={450}
      placement="right"
      closable={false}
      onClose={() => onCancelClick()}
      open={!!payroll}
      keyboard={false}
      maskClosable={false}
    >
      <h3>Observação (Opcional)</h3>
      <ObservacaoTextArea
        data-testid="input-observacao"
        placeholder="Insira aqui uma observação ou comentário"
        rows={6}
        value={observacaoAdmin}
        maxLength={65000}
        type="text"
        onChange={(e) => setObservacaoAdmin(e.target.value)}
      />

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          gap: '10px',
        }}
      >
        <Button
          data-testid="save-payroll-button"
          key="submit"
          type="primary"
          onClick={() => handleUpdatePayrollClick(payroll, { observacaoAdmin })}
          disabled={!observacaoAdmin}
        >
          <CustomText color="white">Salvar</CustomText>
        </Button>

        <Button
          key="back"
          onClick={onCancelClick}
        >
          Cancelar
        </Button>
      </div>
    </Drawer>
  );
}

DrawerEditPayroll.propTypes = {
  payroll: PropTypes.shape(),
  onFinishEditing: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
};

DrawerEditPayroll.defaultProps = {
  payroll: undefined,
};

export default DrawerEditPayroll;
